module.exports = __webpack_public_path__ + "static/media/pos_in_action.097eb935.jpg";